import { put, takeLatest } from 'redux-saga/effects';
import CryptoJS from 'crypto-js';
import * as ActionTypes from '../actions/types';

function* login(action) {
  try {
    const { username, password } = action;
    if ((username === 'admin' || username === 'hr') && password === 'Softech@147258369') {
      yield put({ type: ActionTypes.AUTH_LOGIN_SUCCESS, loggedInUser: { username, password: CryptoJS.MD5(action.password).toString() } });
      localStorage.setItem('loggedInUser', JSON.stringify({ username, password: CryptoJS.MD5(action.password).toString() }));
    } else {
      alert('Đăng nhập không thành công.\nVui lòng thử lại!');
      yield put({
        type: ActionTypes.AUTH_LOGIN_ERROR,
        error: {
          code: 200,
          error: null,
          message: 'Đăng nhập không thành công.\nVui lòng thử lại!',
        },
      });
    }
  } catch (exception) {
    console.log('SAGA ERROR (authSagas):', exception);
    yield put({
      type: ActionTypes.AUTH_LOGIN_ERROR,
      error: exception.response,
    });
  }
}

function* logout() {
  try {
    yield put({ type: ActionTypes.AUTH_LOG_OUT_SUCCESS });
    localStorage.clear();
  } catch (exception) {
    console.log('SAGA ERROR (authSagas):', exception);
  }
}

// sagas
export default function* sagas() {
  yield takeLatest(ActionTypes.AUTH_LOGIN, login);
  yield takeLatest(ActionTypes.AUTH_LOG_OUT, logout);
}
